import React, { useState } from 'react'
import Header from '../../common/header'
import Footer from '../../common/footer'
import SvgIcon from '../../common/svg-icon/svg-icon'
import { Breadcrumb } from 'semantic-ui-react'
import './index.scss'
import SEO from '../../../components/seo/SEO'
import CareesImg from '../../../assets/images/new-images/careers.jpg';
import { NewInviteUser } from '../../common/newInviteUser';
const AccordionItem = ({ title, content, isOpen, onToggle }) => {
  return (
    <div className={`accordion-item ${isOpen ? 'open' : ''}`}>
      <div className="accordion-title" onClick={onToggle}>
        {title} <div className='toggle-icon'>{isOpen ? <SvgIcon name='minus-icon' viewbox="0 0 17 2" /> : <SvgIcon name='plus-icon' viewbox="0 0 17 14" />}</div>
      </div>
      <div className={`accordion-content ${isOpen ? 'open' : ''}`}>
        <div dangerouslySetInnerHTML={{ __html: content }}></div>
      </div>
    </div>
  );
};


const FaqsView = () => {
  const [openAccordion, setOpenAccordion] = useState({ index: null, category: null });
  const [activeTab, setActiveTab] = useState();

  const toggleAccordion = (index, category) => {
    if (openAccordion.category === category && openAccordion.index === index) {
      setOpenAccordion({ index: null, category: null });
    } else {
      setOpenAccordion({ index, category });
    }
  };

  const handleTabClick = (tab) => {
    setActiveTab(tab);
  };

  const GeneralQuestionsItems = [
    {
      title: 'What is Mappes.io?', content: `Mappes is a sales and sourcing partner for advanced manufacturing technologies, backed by a team with over 40 years of cumulative experience in helping global suppliers grow in India and enabling Indian manufacturers to access global innovations. To scale this mission, we’ve built Mappes.io—a digital ecosystem that maps entire value chains, including raw materials, machinery, applications, and suppliers. The platform acts as an enabler, accelerating discovery, visibility, and connections across high-growth sectors like solar, semiconductors, lithium-ion, and more.`
    },
    {
      title: 'How is Mappes.io different from a typical marketplace or listing site?', content: `Unlike static listing directories, Mappes.io dynamically maps technologies and their value chains. You don’t just see product names—you understand how they fit into the bigger manufacturing process. <b> Our team provides hands-on support in sales, sourcing, and post-sale services </b> to accelerate real-world business outcomes.' <br> 
      
      ` }, /*
      <ul>
      <li>Manufacturers and OEMs</li>
      <li>Raw material and equipment suppliers</li>
      <li>Sales and distribution agents</li>
      <li>Procurement and sourcing professionals</li>
      <li>Technical consultants and service providers</li>
      </ul> 
      
      Anyone involved in the industrial B2B landscape can use Mappes.io to grow visibility, access new leads, and explore technology trends.
      */
    {
      title: 'Who can use Mappes.io?', content: ` Mappes is built for stakeholders across the high-tech manufacturing ecosystem: ' <br> 
      <ul>
          <li>Raw material and equipment suppliers</li>
          <li>OEMs and contract manufacturers</li>
          <li>Procurement and sourcing teams</li>
          <li>Technical sales and distributor networks</li>
          <li>Consultants, researchers, and R&D engineers</li>
      </ul>  
      ` },
    {
      title: 'What industries does Mappes serve?', content: `<div>We focus on fast-growing industrial sectors, including. </div>
      <div>
        <br/>  
        <ul>
            <li>Solar Photovoltaics</li>
            <li>Semiconductor Manufacturing</li>
            <li>Optical Fiber</li>
            <li>Carbon Fiber</li>
            <li>Green Hydrogen</li>
            <li>Additive Manufacturing (3D Printing)</li>
            <li>UV/EB Curing and Coating</li>
        </ul>
        <p> More sectors are being added to support the evolving needs of the manufacturing ecosystem. </p>
      </div>
      ` },
  ];

  const SalesSourcingItems = [
    {
      title: 'Can Mappes help Indian manufacturers source global technologies?', content: `
      <div>
         Yes. Our team, with due diligence and deep domain understanding, actively supports Indian manufacturers looking to localize or scale production. Using Mappes.io and our global partner network, we help by:
         
         <br />
        <ul>
            <li> <b> Identifying qualified international suppliers </b> through curated ecosystem pages</li>
            <li> <b> Comparing technologies and pricing </b> to ensure cost-effectiveness</li>
            <li><b>Facilitating trials, samples, or pilot projects </b> for proof of concept</li>
            <li> <b> Providing end-to-end support </b> until the deal is signed</li>
            <li> <b> Offering local customer support </b> for installation, commissioning, and maintenance after the sale</li>
            
        </ul>
        <p> Whether you’re planning new manufacturing lines or upgrading existing ones, we help bridge the gap between discovery and execution. </p>
      </div>
      ` },
    {
      title: 'What if I need help understanding a new technology or manufacturing process?', content: `
      <div>
         Every technology page on Mappes.io is carefully curated with relevant insights that include  process steps, required raw materials, compatible equipment, and mapped suppliers, to help you gain end-to-end clarity.
         
         <br />
         In addition, you can also find:
         <br />
        <ul>
            <li> <b> Webinars, tech talks, and product demos </b> to build domain knowledge</li>
            <li> <b> In-person meetings </b> with our technical and sales team who understand your requirement to assist better.</li>
            <li><b>Whitepapers, case studies, and application notes </b> on the technology page on <a href="https://www.mappes.io/"> Mappes.io </a>.
 You can also reach out directly from product pages or request a callback for personalized assistance.</li>
      
            
        </ul>
        
      </div>
      ` },
    {
      title: 'Do you represent any specific companies?', content: `
      <div>
         Yes. Mappes works with a carefully selected portfolio of global technology suppliers. For many of them, we serve as their <b> exclusive or preferred sales and sourcing partner </b> in India, actively managing outreach, customer engagement, and after-sales coordination.
         
      </div>
      ` },
    {
      title: 'Does Mappes help with after-sales support?', content: `
      <div>
          Yes. Our involvement doesn’t end with a signed deal. We help coordinate:
         <br />
        <ul>
            <li> Installation and commissioning</li>
            <li> Remote troubleshooting</li>
            <li>Ongoing liaison for upgrades or spare parts</li>
        </ul>
        
      </div>
      ` },
  ]

  const PlatformRelatedItems = [
    {
      title: 'How do I create an account on Mappes.io?', content: `
      <div>
         Sign up using your business email address. You’ll receive a secure OTP (one-time password) for login. Add your company name during sign-up to be listed as an official contact point.
      </div>
      ` },
    {
      title: 'How can I list my products or services?', content: `<div> Mappes works through a mapped ecosystem, not static listings. To start:
        <br>
      
         <ul>
          <li>Use the search bar to check if your company or product already exists.</li>
          <li>If not, add your company or product using the menu in the top-right corner.</li>
        </ul>
        </div>` },
    {
      title: 'How does Mappes support networking?', content: `<div> 
       Mappes is built for B2B industrial networking. You can:
      <br>
      <ul>
        <li>  Discover suppliers or customers </b> and message contacts directly.</li>
        <li>  Use the content feed </b> to share updates, milestones, or case studies.</li>
        <li>  Follow product pages </b> and grow your visibility in your target sectors</li>
      </ul>
      </div>` },

    {
      title: 'How can I search for a specific supplier or product?', content: `<div> Use the search bar at the top center of the homepage. Just type in a company name, product keyword, or sector. You’ll see results across technologies, suppliers, and related categories.</div>`
    },

    {
      title: 'How can I promote an event on Mappes?', content: `<div>  You can promote expos, webinars, launches, or summits directly on the platform: 
      <br /> 
       <ul>
        <li> Add event details through the Events section.</li>
        <li> Tag relevant companies, sectors, or technologies.</li>
        <li> Share it via your content feed for more visibility</li>
      </ul> </div>`
    },

    {
      title: 'How can I add content about my technology?', content: `<div>   You can easily share updates, thought leadership, or product insights using the <b>Article</b> feature on Mappes.io. You can also post external links from trusted sources—just like you would on LinkedIn.
 
      <br /> 
      To maximize visibility:
      <br />
       <ul>
        <li>  Use <b>#tags</b> to associate your content with specific products or technologies.</li>
        <li>  Mention companies using <b>@companyname</b> so your post appears in their followers’ feeds</li>
        <li>  Ensure your content is relevant, informative, and aligned with your industry’s interests</li>
      </ul>
      <p> 
      This helps grow awareness, build credibility, and engage with the right audience across the platform
      </p>
       </div>`
    },
  ];

  const BusinessRelatedItems = [

    {
      title: 'How can I list my products or services?', content: `<div>Mappes is not a traditional listing site. Instead, it works through a mapped ecosystem of products and companies.
        <br>
        To get started:
        <br>
         <ul>
            <li>Use the search bar to check if your company is already listed.</li>
            <li>If not, you can add your company or product from the menu at the top right corner of your Home page.</li>
        </ul>
        </div>` },
    {
      title: 'How does Mappes help with networking?', content: `<div>
      Mappes is built for industrial networking. You can:
      <br>
       <ul>
          <li>Discover suppliers and message contacts directly on the platform</li>
          <li>Use the content feed to post updates, case studies, or product news</li>
          <li>Increase your visibility within relevant sectors and grow your professional network</li>
        </ul>
      </div>` },
    {
      title: 'How can I search for a specific supplier or product?', content: `<div>
      Use the search bar at the top center of the homepage. Just type in a name or keyword, and Mappes will show suggestions and relevant results across products, companies, and technologies.
      </div>` },
    {
      title: 'How can I promote an event on Mappes?', content: `<div>
      If you're organizing an expo, summit, or webinar relevant to manufacturing and advanced technologies, you can use Mappes to promote it within the right community.
      <br>
       <ul>
            <li>Go to the Events section and add your event details</li>
            <li>Tag participating companies, technologies, or product categories</li>
            <li>Share the event via the feed to boost visibility among targeted professionals</li>
            <li>Invite attendees to follow your company or product pages for ongoing engagement even after the event</li>
       </ul>
      </div>`
    },
  ];
  
  const HelpRelatedItems = [

    {
      title: 'Can I speak to someone from Mappes directly?', content: `<div> Yes. If you'd like to explore partnerships, need help sourcing a product, or want assistance navigating the platform, simply reach out via the Contact Us form or message from any product page. We’ll connect you with the right team member.

        </div>` },
    ]

  const sections = [
    { key: 'Home', content: 'Home', link: true, href: '/' },
    { key: 'ecosystem', content: 'Ecosystem', link: false },
  ]

  return (
    <>
      <SEO key="faqs-seo"
        robots="index, follow"
        canonicalUrl="/faqs"
        alternateLink="/faqs"
        pageType={'faqs'}

      />
      <Header />
      <div className='faqs-view'>
        <section className='breadcrumb-section'>
          <div className='mappes-container'>
            <Breadcrumb icon={<SvgIcon name='chevron-right' viewbox="0 0 8 14" />} sections={sections} />
          </div>
        </section>
        <section className='banner-section'>
          <div className='mappes-container'>
            <div className='banner-card'>
              <img className='banner-img' src={CareesImg} alt='' />
              <div className='overlay-div'>
                <h2>We have all your answers!</h2>
              </div>
            </div>
          </div>
        </section>
        <section className='faqs-section'>
          <div className='mappes-container'>
            <ul className='nav-tabs'>
              <li className={activeTab === 'General' ? 'active' : ''} onClick={() => handleTabClick('General')}>
                <a href='#General'>General</a>
              </li>
              
              <li className={activeTab === 'SalesRelated' ? 'active' : ''} onClick={() => handleTabClick('SalesRelated')}>
                <a href='#SalesRelated'>Sales, Sourcing & Services</a>
              </li>

              <li className={activeTab === 'PlatformRelated' ? 'active' : ''} onClick={() => handleTabClick('PlatformRelated')}>
                <a href='#PlatformRelated'>Platform Related</a>
              </li>
              <li className={activeTab === 'BusinessRelated' ? 'active' : ''} onClick={() => handleTabClick('BusinessRelated')}>
                <a href='#BusinessRelated'>Business Related</a>
              </li>
            </ul>
            <h2 id='General'>General Questions</h2>
            <div className="accordion">
              {GeneralQuestionsItems.map((item, index) => (
                <AccordionItem
                  key={"GQI_" + index}
                  title={item.title}
                  content={item.content}
                  isOpen={openAccordion.category === 'General' && openAccordion.index === index}
                  onToggle={() => toggleAccordion(index, 'General')}
                />
              ))}
            </div>
            <h2 id='SalesRelated'>Sales, Sourcing & Services</h2>
            <div className="accordion">
              {SalesSourcingItems.map((item, index) => (
                <AccordionItem
                  key={"SSI-" + index}
                  title={item.title}
                  content={item.content}
                  isOpen={openAccordion.category === 'Sales' && openAccordion.index === index}
                  onToggle={() => toggleAccordion(index, 'Sales')}
                />
              ))}
            </div>
            <h2 id='PlatformRelated'>Platform Related</h2>
            <div className="accordion">
              {PlatformRelatedItems.map((item, index) => (
                <AccordionItem
                  key={"PRI-" + index}
                  title={item.title}
                  content={item.content}
                  isOpen={openAccordion.category === 'Platform' && openAccordion.index === index}
                  onToggle={() => toggleAccordion(index, 'Platform')}
                />
              ))}
            </div>
            <h2 id='BusinessRelated'>Business Related</h2>
            <div className="accordion">
              {BusinessRelatedItems.map((item, index) => (
                <AccordionItem
                  key={"BR-" + index}
                  title={item.title}
                  content={item.content}
                  isOpen={openAccordion.category === 'Business' && openAccordion.index === index}
                  onToggle={() => toggleAccordion(index, 'Business')}
                />
              ))}
            </div>
            <h2 id='HelpRelated'>Need More Help?</h2>
            <div className="accordion">
              {HelpRelatedItems.map((item, index) => (
                <AccordionItem
                  key={"HR-" + index}
                  title={item.title}
                  content={item.content}
                  isOpen={openAccordion.category === 'Help' && openAccordion.index === index}
                  onToggle={() => toggleAccordion(index, 'Help')}
                />
              ))}
            </div>
          </div>
        </section>
        <section className='mappessubcribe-section'>
          <div className='mappes-container'>
            <div className='mappessubcribe-card'>
              <div className='mappessubcribe-row'>
                <h2>Reach out to us if you <br /> have any queries!</h2>
                <NewInviteUser />
              </div>
            </div>
          </div>
        </section>
      </div>
      <Footer />
    </>
  )
}

export default FaqsView